export default __webpack_public_path__ + "static/media/Avatar-13.cd775c93.svg";